import React, { useEffect, useState } from "react";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import { Card, Modal, Button } from "react-bootstrap";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";

function PincodeView(props) {
  var history = useHistory();
  const [searchData, setSearchData] = useState([]);
  const [pinCodes, setPinCodes] = useState("");
  const [pinId, setPinId] = useState("");
  const [show, setShow] = useState(false);
  const { id } = props.match.params;
  function getData() {
    axios
      .get(`${Baseurl.baseurl}/go-pincode/get-all-pincodes`)
      .then((response) => {
        response.data.pincodes.map((val) => {
          if (val.Name.includes(id)) {
            setPinCodes(val.PinCode);
            setSearchData(val.PinCode)
            setPinId(val._id);
          }
        });
      })
      .catch((err) => console.log(err));
  }
  useEffect(() => {
    getData();
  }, []);

  function deletePincode() {
    axios
      .delete(Baseurl.baseurl + `/go-pincode/delete-geo-fence/${pinId}`)
      .then((response) => {
        if (response.data.status) {
          setPinCodes("");
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      });
    setShow(false);
  }
  const searchFunction=(value)=>{
    let filteredData = [];
    searchData.map((val) => {
      if (
        val.toString().includes(value) 
      ) {
        filteredData.push(val);
      }
    });
    setPinCodes(filteredData);
  }
  return (
    <>
      <Modal
        size="lg"
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Body>
          <h4>
            Are you sure !! you want to delete All Pincodes of{" "}
            <text className="text-danger ml-1">{id}</text>{" "}
          </h4>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              deletePincode();
            }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      <Card  style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}>
        <Card.Header>
        <button
            onClick={() => {
              setShow(true);
            }}
            className="btn btn-danger"
          >
            Delete All
          </button>
        <div className="input-group search-area d-lg-inline-flex d-none">
            <div className="input-group-append">
              <button className="input-group-text">
                <i className="flaticon-381-search-2" />
              </button>
            </div>
            <input
              type="text"
              id="myInput"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchFunction(e.target.value);
              }}
            />
          </div>
         
          <button
            className="btn btn-primary"
            onClick={() => {
              history.push(`/city/${localStorage.getItem("sname")}`);
            }}
          >
            Back
          </button>
        </Card.Header>
        <Card.Body>
          <div className="row">
          {pinCodes &&
                pinCodes.map((val) => {
                  return (
                    <div className="col-sm-2 p-2">
                      <strong>{val}</strong>
                      </div> 
                  );
                })}
          </div>
        </Card.Body>
      </Card>
    </>
  );
}
export default PincodeView;
